import { Injectable } from '@angular/core';

import { StudentGradeLevelServiceMock } from '@app/core/services/student-grade-level/student-grade-level.service.mock';

@Injectable()
export class StudentGradeLevelService extends StudentGradeLevelServiceMock {}
